import * as focusTrap from 'focus-trap'
import { onClickOutsideOf } from '~/js/utils'

const SELECTORS = {
	toggleButton: '.js-site-navtoggle'
}

const CLASSES = {
	bodyClass: 'no-scroll',
	isOpen: 'is-open'
}

class MainNavigation extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.elements = {
			nav: this.querySelector('nav'),
			toggleBtn: this.querySelector(SELECTORS.toggleButton),
            submenu: this.querySelector('[data-submenu]')
		}

		this.focusTrap = focusTrap.createFocusTrap(this, {
            allowOutsideClick: true,
			onDeactivate: () => this.toggleMenu(false)
		})
		this.bindEvents()
	}

	bindEvents() {
		const { toggleBtn } = this.elements
		this.outsideClickHandler = null
		toggleBtn.addEventListener('click', () => this.toggleMenu())
        const submenuToggleButtons = this.querySelectorAll('[data-submenu-toggle]:not(.is-active)');
		submenuToggleButtons && submenuToggleButtons.forEach(button => button.addEventListener('click', () => this.toggleSubmenu(button, button.nextElementSibling)));
	}

	toggleMenu = (force) => {
		const { toggleBtn, nav } = this.elements
		const isOpen =
			typeof force === 'boolean' ? force : !this.hasAttribute('open')

		// scroll to the very top of the page. The navigation is fixed and any spacing from top would result in a "gap", unless scrolled at the very top.
		window.scrollTo(0, 0);

		toggleBtn.setAttribute('aria-expanded', String(isOpen))
		nav.classList.toggle(CLASSES.isOpen, isOpen)
		document.body.classList.toggle(CLASSES.bodyClass, isOpen)

		if (isOpen) {
			this.setAttribute('open', '')
			this.focusTrap.activate()
		} else {
			this.removeAttribute('open')
			this.focusTrap.deactivate()
		}
	}

    toggleSubmenu = (button, submenu) => {
        const currentlyOpenSubmenus = this.querySelectorAll('[data-submenu].is-open');
        const currentlyOpenSubmenuButtons = this.querySelectorAll('[data-submenu-toggle].is-open');

        button.classList.toggle('is-open');
        submenu.classList.toggle('is-open');

        currentlyOpenSubmenus.forEach(submenu => submenu.classList.remove('is-open'));
        currentlyOpenSubmenuButtons.forEach(submenu => submenu.classList.remove('is-open'));
    }
}

customElements.define('main-navigation', MainNavigation)
